<template>
  <v-container>
    <v-row class="justify-center pt-5">
      <v-col cols="12">
        <v-card class="mx-auto pa-5" outlined>
          <v-card-title>{{ lg_appid_edit.title }}</v-card-title>
          <v-divider></v-divider>
          <br />
          <v-form @submit.prevent="submit">
            <v-text-field
              :label="lg_appid_edit.appid_id"
              v-model="appid.id"
              disabled
            />

            <v-text-field
              outlined
              :label="lg_appid_edit.appid_name"
              v-model="appid.app_id_name"
            ></v-text-field>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn class="mr-4" @click.prevent="cancel">
                {{ lg_appid_edit.btn_cancel }}
              </v-btn>

              <v-btn color="success" type="submit">
                {{ lg_appid_edit.btn_save }}
              </v-btn>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <LoadingDialog></LoadingDialog>
    <!-- Alert Dialog -->
    <v-dialog v-model="alertDlg" max-width="60%">
      <v-card>
        <v-card-title class="headline">{{
          this.titleMessageAlert
        }}</v-card-title>

        <v-card-text class="body">
          {{ this.messageAlert }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            text
            @click="alertDlg = false"
            col="12"
            lg="12"
            md="12"
            sm="12"
          >
            Close
          </v-btn>

          <!-- <v-btn outlined color="error" text @click="confirmDelete">
            Confirm
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Alert Dialog -->
  </v-container>
</template>
<script>
import api from "@/services/api";
import LoadingDialog from "../../components/cards/LoadingDialog.vue";

import { feature } from "../../services/constants";
import { lg_appid_edit } from "../language/lg_appid";

export default {
  name: "appid-edit",
  beforeCreate() {
    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_appid_edit = lg_appid_edit.appid_edit_th)
      : (this.lg_appid_edit = lg_appid_edit.appid_edit_en);

    // console.log("lg_appid_edit: " + JSON.stringify(this.lg_appid_edit));
  },
  data: () => ({
    alertDlg: false,
    titleMessageAlert: "",
    messageAlert: "",
    appid: { id: 0, app_id_name: "" },
  }),
  components: {
    LoadingDialog,
  },
  async mounted() {
    this.$store.state.loadMenu = true;
    // get params id to show
    this.appid.id = this.$route.params.id;
    let result = await api.getAppIdByID(this.appid.id);
    this.appid = result.data;
    this.$store.state.loadMenu = false;
  },
  methods: {
    async submit() {
      // console.log(server.AppId_URL);
      // console.log(JSON.stringify(this.AppId));
      // alert(JSON.stringify(this.AppId));
      this.$store.state.loadMenu = true;
      const result = await api.checkNameForUpdateAppId(
        this.appid.id,
        this.appid.app_id_name
      );
      if (result.data != null) {
        // this.titleMessageAlert = "กรุณาตรวจสอบข้อมูล";
        // this.messageAlert = "AppId นี้ถูกใช้งานแล้ว กรุณาเปลี่ยน AppId ใหม่";
        this.titleMessageAlert = this.lg_appid_edit.titleMessageAlert;
        this.messageAlert = this.lg_appid_edit.messageAlert;
        this.alertDlg = true;
        this.$store.state.loadMenu = false;
      } else {
        await api.updateAppId(this.appid.id, this.appid);
        this.$router.back();
      }
    },
    cancel() {
      this.$router.back();
    },
  },
};
</script>

<style></style>
